import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonsConfiguration } from 'src/app/configuration/commons/commons-configuration';
import { ListaCorsiView } from 'src/app/model/lista-corsi-view';
@Injectable({
  providedIn: 'root'
})
export class CommonsService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }
  // dettaglio profilo
  getProfiloDettaglio(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getProfiloDettaglio + id, { headers: this.headers });
  }

  getCodiciAdaByIdProposta(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciAdaByIdProposta + id, { headers: this.headers });
  }

  getCodiciAtecoByIdProposta(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciAtecoByIdProposta + id, { headers: this.headers });
  }

  getCodiciIscoByIdProposta(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciIscoByIdProposta + id, { headers: this.headers });
  }

  getCodiciIstatByIdProposta(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciIstatByIdProposta + id, { headers: this.headers });
  }

  getCompetenzeByIdProposta(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCompetenzeByIdProposta + id, { headers: this.headers });
  }

  getCompetenzeByPropostaIdAndTipologiaIdAndDescrizione(payload : any): Observable<any> {
    return this.http.post<any>(`${CommonsConfiguration.getCompetenzeByPropostaIdAndTipologiaIdAndDescrizione}`, payload, { headers: this.headers });
  }

  getSottoCategoriaCompetenzaDiBase(): Observable<any> {
    return this.http.get<any>(`${CommonsConfiguration.getSottoCategoriaCompetenzaDiBase}`, { headers: this.headers });
  }

  getCompetenzeByTipologiaIdAndDescrizione(payload : any): Observable<any> {
    return this.http.post<any>(`${CommonsConfiguration.getCompetenzeByTipologiaIdAndDescrizione}`, payload, { headers: this.headers });
  }

  getTipologiaAreaProfilo(payload : any): Observable<any> {
    return this.http.post<any>(`${CommonsConfiguration.getTipologiaAreaProfilo}`,  payload,{ headers: this.headers });
  }

  getAbilitaByCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getAbilitaByCompetenza + id, { headers: this.headers });
  }

  getConoscenzeByCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getConoscenzeByCompetenza + id, { headers: this.headers });
  }

  getCompetenzaDettaglio(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCompetenzaDettaglio + id, { headers: this.headers });
  }

  getCodiciAdaByIdCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciAdaByIdCompetenza + id, { headers: this.headers });
  }

  getCodiciAtecoByIdCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciAtecoByIdCompetenza + id, { headers: this.headers });
  }

  getCodiciIscoByIdCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciIscoByIdCompetenza + id, { headers: this.headers });
  }

  getCodiciIstatByIdCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getCodiciIstatByIdCompetenza + id, { headers: this.headers });
  }

  getProfiliProfessionaliByIdCompetenza(id:any): Observable<any> {
    return this.http.get<any>(CommonsConfiguration.getProfiliProfessionaliByIdCompetenza + id, { headers: this.headers });
  }


  //CORSI
  ricercaCorsi(idPercorso: number, tipoPercorso: number): Observable<ListaCorsiView[]> {
    return this.http.get<ListaCorsiView[]>(CommonsConfiguration.getListaCorsi + '/' + idPercorso + '/' + tipoPercorso);
  }
}
